export function sanitizeString(value) {
	if (!value) return "";
	return String(value)
		.trim()
		.replace(/[<>"]/g, "");
}

export function sanitizeFilename(name) {
	if (!name) return "";
	return name
		.trim()
		.replace(/[^a-zA-Z0-9-_\.]/g, ""); 
}

export function validateFile(file) {
	if (!file || !(file instanceof File)) {
		throw new Error("Invalid file object");
	}
}



// WEBPACK FOOTER //
// ./src/utils/sanitize.js